export const ASC = 'ASC'
export const DESC = 'DESC'

export const sortBy = {
  DATE: 'DATE',
  DELAY: 'DELAY',
  ARREARAGE: 'ARREARAGE',
}
